import {publish} from 'ert-framebus';
import {PubSubMessages} from '../config';
import {loggerFactory} from 'ert-logger';
import {ProductProvidedData} from 'navigator-header';
import {environment} from '../../environments/environment';

const logger = loggerFactory.createLogger('global header');

/*
* Redirects to navigator
* */
export function redirectToNavigator(productProvidedData?: ProductProvidedData) {
  productProvidedData = productProvidedData || {};
  if (!productProvidedData.destinationUrl) {
    productProvidedData.destinationUrl = window.location.href;
  }

  productProvidedData =  removeExtraData(productProvidedData);

  const data = encodeURIComponent(JSON.stringify(productProvidedData));
  const redirectUrl = `${environment.navigatorBaseUrl}redirect?rs=${data}`;
  logger.info(`navigator redirect: ${redirectUrl}`);

  // debug setting, if autoRedirectDisabled = true, then stop redirecting
  const autoRedirectDisabled = localStorage.getItem('autoRedirectDisabled') === 'true';
  if (!autoRedirectDisabled) {
    window.location.href = redirectUrl;
  }
}

function removeURLParameter(url: string, parameter: string) {
  const urlparts = url.split('?');

  if (urlparts.length >= 2) {
    const prefix = `${encodeURIComponent(parameter)}=`;
    const pars = urlparts[1].split(/[&;]/g);

    for (let i = pars.length - 1; i >= 0; --i) {
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    return urlparts[0] + (pars.length > 0 ? `?${pars.join('&')}` : '');
  }
  return url;
}

function removeExtraData(productProvidedData: ProductProvidedData) {
  // sometimes the length from id_token and destinationUrl is too big,and
  // the gsso api oauth2/authorize will failed due to exceed url size limitation

  // not sure if we really need the id_token for navigator
  productProvidedData.idToken = null;

  // sometimes we need to pass the destinationUrl to the navigator but we don't need id_token and state parameter
  // in the destination url because these values are already stored separately or not needed.
  if (productProvidedData.destinationUrl) {
    if (productProvidedData.destinationUrl.indexOf('id_token=') !== -1) {
      productProvidedData.destinationUrl = removeURLParameter(productProvidedData.destinationUrl, 'id_token');
    }
    if (productProvidedData.destinationUrl.indexOf('state=') !== -1) {
      productProvidedData.destinationUrl = removeURLParameter(productProvidedData.destinationUrl, 'state');
    }
  }

  return productProvidedData;
}

export function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

export function startActivityTracking() {
    startTrackingUserActivity();
    startTrackingUrlChanges();
    startTrackingPageTitle();
}

/*
* Starts tracking user clicks
* */
function startTrackingUserActivity() {
    document.addEventListener('mousedown', setActivity, true);
    document.addEventListener('keydown', setActivity, true);
}

/*
* Starts tracking window url changes
* Sends messages with url data to the parent window
* */
function startTrackingUrlChanges() {
    try {
      let oldHref = document.location.href;
      const targetNode = document.querySelector('body');

      setUrlChanged(oldHref);
      new MutationObserver(mutations => {
          mutations.forEach(mutation => {
              const href = document.location.href;
              if (oldHref !== href) {
                  oldHref = href;
                  setUrlChanged(href);
              }
          });
      }).observe(targetNode, {childList: true, subtree: true});
    } catch (error) {
        logger.info(`global header: ${error}`);
    }
}

/*
* Starts tracking the page title changes
* Sends messages about page title to the parent window
* */
function startTrackingPageTitle() {
    try {
      const targetNode = document.querySelector('title');

      setPageTitle(document.title);
      new MutationObserver(mutations => {
          // @ts-ignore: ignore undefined text error
          const title = mutations[0].target.text || '';
          if (title) {
              setPageTitle(title);
          }
      }).observe(targetNode, {childList: true, characterData: true});
    } catch (error) {
        logger.info(`global header: page title is missing: ${error}`);
    }
}

function setUrlChanged(url: string) {
    publish(PubSubMessages.urlChanged, url);
}

function setActivity() {
    publish(PubSubMessages.activityData);
}

function setPageTitle(pageTitle: string) {
    publish(PubSubMessages.pageTitle, pageTitle);
}
